<template>
  <div>
    <div class="mb-2 mt-1">
      <el-radio-group v-model="field.is_global_variable">
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>

    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="30" class="">
        <el-col :span="8">
          <el-form-item>
            <label
              class="field-title-label d-block w-100 text-lightGray text-xs 2xl:!text-sm font-normal !mb-1"
            >
              Rows
            </label>
            <el-input-number
              v-model="field.tableProperties.rows"
              :min="1"
              @change="updateTableProperties"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <label
              class="field-title-label d-block w-100 text-lightGray text-xs 2xl:!text-sm font-normal !mb-1"
            >
              Columns
            </label>
            <el-input-number
              v-model="field.tableProperties.columns"
              :min="1"
              @change="updateTableProperties"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <label
              class="field-title-label d-block w-100 text-lightGray text-xs 2xl:!text-sm font-normal !mb-1"
            >
              Border Size
            </label>
            <el-input-number
              v-model="field.tableProperties.borderSize"
              @change="updateTableProperties"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="30" class="mb-3">
        <el-col :span="8">
          <el-form-item>
            <label
              class="field-title-label d-block w-100 text-lightGray text-xs 2xl:!text-sm font-normal !mb-1"
            >
              Cell Spacing
            </label>
            <el-input-number
              v-model="field.tableProperties.cellSpacing"
              @change="updateTableProperties"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <label
              class="field-title-label d-block w-100 text-lightGray text-xs 2xl:!text-sm font-normal !mb-1"
            >
              Cell Padding
            </label>
            <el-input-number
              v-model="field.tableProperties.cellPadding"
              @change="updateTableProperties"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-form label-position="right" v-if="field.is_global_variable">
      <el-row type="flex" :gutter="30">
        <el-col :span="8">
          <el-form-item label="Global Table Variable">
            <el-select v-model="field.global_variable_id" @change="setGlobalVariable">
              <el-option
                v-for="(globalVariable, index) of allGlobalVariables"
                :key="index"
                :label="globalVariable.label"
                filterable
                :value="globalVariable._id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  //import { mapGetters } from "vuex";
  import { fetchGlobalVariables } from '@/repo/globalVariables';

  export default {
    name: 'table-properties',
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
    },

    props: ['field'],

    computed: {
      //...mapGetters("globalVariables", ["getAllGlobalVariables"]),
      allGlobalVariables() {
        return this.getAllGlobalVariables ? this.getAllGlobalVariables.data || [] : [];
      },
    },

    mounted() {
      this.fieldData = this.field;
      this.fetchGlobalVariables();

      if (!this.field.tableProperties) {
        this.$set(this.field, 'tableProperties', {
          rows: 1,
          columns: 1,
          borderSize: 0,
          cellPadding: 0,
          cellSpacing: 0,
        });
      }
    },

    data() {
      return {
        fieldData: null,
        getAllGlobalVariables: null,
      };
    },

    methods: {
      async fetchGlobalVariables() {
        const params = {
          get_all: true,
          input_type: this.field.input_type,
        };
        this.getAllGlobalVariables = await fetchGlobalVariables(params);
      },

      setGlobalVariable() {
        const globalVariable = this.allGlobalVariables.find(
          (x) => x._id == this.field.global_variable_id
        );
        this.field.label = globalVariable.label;
        this.field.description = globalVariable.description;
        this.field.options = globalVariable.options;
      },

      updateTableProperties() {
        this.$emit('update-table-properties', this.field);
      },
    },
  };
</script>

<style lang="scss"></style>
